module.exports = __webpack_public_path__ + "static/media/shape.208f3d38.svg";